import { registerMapper } from './register.js';

registerMapper('simple', (item) => ({
    title: item.title || '',
    description: item.description || ''
}));
